import { render, staticRenderFns } from "./PondSettingEdit.vue?vue&type=template&id=3755f282&"
import script from "./PondSettingEdit.vue?vue&type=script&lang=js&"
export * from "./PondSettingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports